/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react'
import { useAuth } from '../../hooks/auth'
import { apiAuth } from '../../services/apiAuth'

export type SuppliersData = {
  id: string
  trading_name: string
}

type CostOfCenterData = {
  id: string
  name: string
  is_default?: boolean
}

interface Categories {
  id: number
  name: string
  name_es: string
  name_en: string
  name_ptbr: string
  is_active: boolean
}

type SupplierData = SuppliersData | null

export const useService = () => {
  // hooks
  const { decodeToken } = useAuth()

  // State
  const [suppliers, setSuppliers] = useState<SuppliersData[]>([])
  const [recoverSuppliers, setRecoverSuppliers] = useState<SupplierData>(null)
  const [costOfCenter, setCostOfCenter] = useState<CostOfCenterData[]>([])
  const [categories, setCategories] = useState<Categories[]>([])

  const getCostsByClinicId = useCallback(async () => {
    try {
      const { data } = await apiAuth.get(`clinics/cost-centers/`, {
        params: {
          is_active: true
        }
      })

      setCostOfCenter(data.results)
    } catch (error) {
      console.log('Error getting Cost', error)
    }
  }, [])

  const getSuppliersByClinicId = useCallback(async () => {
    try {
      const { data } = await apiAuth.get(`clinics/suppliers/`, {
        params: {
          is_active: true,
          noPaginate: '1'
        }
      })

      setSuppliers(data)
    } catch (error) {
      console.log('Error getting Suppliers', error)
    }
  }, [])

  const getSupplierById = useCallback(async (id: string) => {
    try {
      const { data } = await apiAuth.get(`clinics/suppliers/${id}/`)

      setRecoverSuppliers(data)
    } catch (error) {
      console.log('Error getting Suppliers', error)
    }
  }, [])

  const getCategoriesAllClinics = useCallback(async () => {
    const { data } = await apiAuth.get('clinics/payable-categories/')
    setCategories(data?.results)
  }, [])

  useEffect(() => {
    const loadingInfos = async () => {
      await getCostsByClinicId()
      await getSuppliersByClinicId()
      await getCategoriesAllClinics()
    }

    loadingInfos()
    return () => {}
  }, [])

  // Get Value of my select Supplier
  const newSuppliersFormats = suppliers.map((supplier: SuppliersData) => {
    return {
      value: String(supplier.id),
      label: supplier.trading_name
    }
  })

  // Get Value of my select Cost
  const newCostsFormats = costOfCenter.map((cost: CostOfCenterData) => {
    return {
      value: String(cost.id),
      label: cost.name,
      is_default: cost.is_default
    }
  })

  // Get Values of my select Category
  const newCategoriesFormats = categories.map((category: Categories) => {
    let name = ''

    switch (decodeToken.clinic_language) {
      case 'en':
        name = category.name_en
        break
      case 'es':
        name = category.name_es
        break

      default:
        name = category.name_ptbr
        break
    }

    return {
      value: String(category.id),
      label: name
    }
  })

  return {
    newSuppliersFormats,
    newCostsFormats,
    newCategoriesFormats,
    setSuppliers,
    getSupplierById,
    recoverSuppliers,
    suppliers
  }
}
